module.exports = __webpack_public_path__ + "img/main-02-07-more.18022302.png";